import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from "@angular/router";
import packageJson from '../../../../../package.json';

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit {

  profileOption = false;
  SSOUrl;
  socialLinks: Record<string, string> = {};
  copyRightYear: string = "2023";
  appVersion: string = packageJson.version;

  constructor(private router: Router) { }

  ngOnInit() {
    this.socialLinks.linkedin = "https://www.linkedin.com/company/signifycompany/";
    this.socialLinks.twitter = "https://twitter.com/signifycompany";
    this.socialLinks.instagram = "https://www.instagram.com/Signifycompany";
    this.socialLinks.pinterest = "https://www.pinterest.com/signifycompany/";
    this.socialLinks.youtube = "https://www.youtube.com/c/SignifyCompany";

    this.copyRightYear = new Date().getFullYear().toString();
  }

  socialLink(link) {
    window.open(link, '_blank');
  }

  navigateToAbout() {
    this.router.navigate(["/about"]);
  }
}





